import { RefreshCcw } from 'lucide-react';
import React, { FC, useEffect, useState } from 'react';

import { LoadingOutlined } from '@ant-design/icons';

import { postToAPI } from '~utils/api/common';

interface Props {
  phone: string;
  name: string;
  smsEndpoint?: string;
}

const ResendCodeButton: FC<Props> = ({
  phone,
  name,
  smsEndpoint = '/uas-students/send-sms-code',
}) => {
  const [loading, setLoading] = useState(false);
  const [seconds, setSeconds] = useState(60);
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (seconds) setSeconds((_seconds) => _seconds - 1);
    }, 1000);
    return () => clearTimeout(timeout);
  }, [seconds]);

  const resendCode = () => {
    setLoading(true);
    postToAPI(smsEndpoint, { name, phone })
      .then(() => {
        setSeconds(60);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  if (seconds) return <p>Reenviar código en {seconds}s</p>;
  return (
    <button className="btn btn-sm dark:btn-dark" onClick={() => resendCode()} type="button">
      {loading ? <LoadingOutlined /> : <RefreshCcw size={16} />}
      <span>Reenviar código</span>
    </button>
  );
};

export default ResendCodeButton;
